// utils/axiosInterceptor.ts
import axios from 'axios';
import { generateToken } from "../helpers/common";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BASE_TIMEOUT_MS = 30000; // Initial response timeout (30 seconds) 30000
const TOP_UP_MS = 10000; // Additional timeout (10 seconds) 10000
const MAX_TIMEOUT_MS = BASE_TIMEOUT_MS + TOP_UP_MS; // Maximum timeout (40 seconds)

let currentTimeout = BASE_TIMEOUT_MS;


const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, // Replace with your API base URL
  timeout: currentTimeout,
});


// Add a request interceptor
axiosInstance.interceptors.request.use(
  config => {
    const token = generateToken();

    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    config.headers['Content-Type'] = 'application/json';
    return config
  },
  error => {
    Promise.reject(error)
  }
);

axiosInstance.interceptors.response.use(
    response => {
    // Handle successful response
    return response;
    },
    error => {
      
    // Handle error response
     if (error.code === 'ECONNABORTED') {
      // console.warn('Request timeout detected');
      if (currentTimeout < MAX_TIMEOUT_MS) {
        currentTimeout += TOP_UP_MS;
        // console.warn(`Increasing timeout to ${currentTimeout} ms`);
      } 
      // else {
      //   console.error('Maximum timeout reached. Handling error...');
      // }
    }
    if(error.code === 'ERR_NETWORK') { // Handle network error
        // console.error('Network error:', error.message);
        const isNetworkError = JSON.parse(localStorage.getItem("isNetworkError")) || false;
        
        if(isNetworkError === false) {
          toast.info("Please check your internet connection.", { type: "error" });
          localStorage.setItem("isNetworkError",true);
          setTimeout(() => {
            localStorage.setItem("isNetworkError", false);
          }, 5000); // Reset the flag after 5 seconds
        }
    }
    // console.error('Response error:', error.response.status, error.response.data);
    if (error.response.status === 401) {
        // Redirect to login or refresh token
        // Example: window.location.href = '/login';
    }
    return Promise.reject(error);
    }
);

export default axiosInstance;
